// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var OffsetModeViewEnum;
(function (OffsetModeViewEnum) {
    OffsetModeViewEnum[OffsetModeViewEnum["Ticks"] = 0] = "Ticks";
    OffsetModeViewEnum[OffsetModeViewEnum["TicksFractionalForForex"] = 1] = "TicksFractionalForForex";
    OffsetModeViewEnum[OffsetModeViewEnum["Points"] = 2] = "Points";
    OffsetModeViewEnum[OffsetModeViewEnum["Percent"] = 3] = "Percent";
})(OffsetModeViewEnum || (OffsetModeViewEnum = {}));
export function getOffsetModeViewEnumKey(value) {
    switch (value) {
        case OffsetModeViewEnum.Ticks:
            return 'property.OffsetMode.Ticks';
        case OffsetModeViewEnum.TicksFractionalForForex:
            return 'property.OffsetMode.TicksFractionalForForex';
        case OffsetModeViewEnum.Points:
            return 'property.OffsetMode.Points';
        case OffsetModeViewEnum.Percent:
            return 'property.OffsetMode.Percent';
        default:
            return '';
    }
}
